export default {
  created() {
    if (this.$options.handleStorageCleanup) {
      window.addEventListener('beforeunload', this.handleBeforeUnload);
      window.addEventListener('unload', this.handleUnload);
    }
  },
  beforeDestroy() {
    if (this.$options.handleStorageCleanup) {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
      window.removeEventListener('unload', this.handleUnload);
    }
  },
  methods: {
    handleBeforeUnload() {
      const journeyComplete = localStorage.getItem('journeyComplete') === 'true';
      if (!journeyComplete) {
        this.clearSensitiveData();
      }
    },
    handleUnload() {
      // Final cleanup on page unload
      const journeyComplete = localStorage.getItem('journeyComplete') === 'true';
      if (!journeyComplete) {
        this.clearSensitiveData();
      }
    },
    clearSensitiveData() {
      const sensitiveKeys = ['patientData', 'medicalHistory', 'insurance'];
      sensitiveKeys.forEach(key => localStorage.removeItem(key));
    }
  }
}